import { helper } from '@ember/component/helper'
import { get } from '@ember/object'
import { isPresent } from '@ember/utils'

interface Signature {
  Args: {
    Positional: [unknown, unknown]
  }
  Return: boolean
}

export const includes = helper<Signature>(function ([obj, item]) {
  if (Array.isArray(obj)) {
    return obj.includes(item)
  }
  if (obj !== null && typeof obj === 'object' && 'includes' in obj && typeof obj.includes === 'function') {
    return obj.includes(item)
  }
  if (obj !== null && typeof obj === 'object' && typeof item === 'string') {
    return isPresent(get(obj, item))
  }
  return false
})

export default includes
